
export default class Pagination {

    async init(): Promise<void> {
        this.changePaginationPosition();
        jQuery(document).on('ajaxComplete', () => this.changePaginationPosition());
    }

    async changePaginationPosition(): Promise<void> {
        const archivePagination: HTMLElement | null = document.querySelector(`${wcapf_params.shop_loop_container} .woocommerce-pagination`) as HTMLElement;
        const archivePaginationPlaceholder: HTMLElement | null = document.querySelector('.shop-wrapper .pagination-placeholder') as HTMLElement;

        if (archivePagination && archivePaginationPlaceholder) {
            archivePaginationPlaceholder.innerHTML = '';
            archivePaginationPlaceholder.appendChild(archivePagination);
            archivePaginationPlaceholder.querySelector('.woocommerce-pagination')?.classList.remove('hidden');
        }
    }
}